import React, { useEffect, useRef, useState } from "react";

import { Checkbox, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import DeleteModal from "../../../../components/Common/DeleteModal.js";
import Label from "../../../../components/Common/Label";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from "../../../../components/Common/Notification";
import SearchBar from "../../../../components/Common/Searchbar";
import Table from "../../../../components/Common/Table";
import TablePageControl from "../../../../components/Common/TablePageControl";
import CustomButton from "../../../../components/Form/CustomButton";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../../components/Form/CustomSelect2";
import CustomTextField from "../../../../components/Form/CustomTextField.js";
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup.js";
import RenderPopOverButton from "../../../../components/Form/RenderPopOverButton.js";
import Helpers from "../../../../helpers/helpers";
import { bulkDeleteCategory, bulkUpdateCategory, deleteCategory, exportCategory, getCategoryListing, getGeneral, resetCategoryAttachmentState, resetCategoryState } from "../../../../store/actions";
import "../../setting.css";


const ProductCategoriesSetting = ({ categoryListing, exportCategoryDocument, userPermission, deleteCategoryItem, bulkDelete, error, bulkUpdate }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [filterNavigation, setFilterNavigation] = useState("all");
    const [filterType, setFilterType] = useState("all");
    const [selectedRow, setSelectedRow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc")
    const [sort_by, setSortBy] = useState("id")
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        dispatch(resetCategoryState());
    }, []);
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [listing, setListing] = useState("");
    const [bulkEdit, setBulkEdit] = useState(false);
    const searchRef = useRef(keyword);

    const statusListing = [
        { label: "All statuses", value: "all" },
        { label: "Published", value: "1" },
        { label: "Unpublished", value: "0" },
    ]

    const typeListing = [
        { label: "All types", value: "all" },
        { label: "Top-level", value: "top_level" },
        { label: "Subcategory", value: "subcategory" },
    ]

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        initData();
    }, [page, length, sort, filterStatus, sort_by, filterNavigation, filterType])

    useEffect(() => {
        if (deleteCategoryItem?.code === "success") {
            setIsLoading(false);
            setNotification({ open: true, msg: "Category deleted successfully", type: "success" });
            dispatch(resetCategoryState());
            setDeleteOpen(false)
            dispatch(getGeneral());
            setPage('1');
            initData();
        } else if (deleteCategoryItem?.code === "invalid_field") {
            setIsLoading(false);
            setDeleteOpen(false);
            const errorMessage = deleteCategoryItem?.errors?.parent?.[0]
                || deleteCategoryItem?.errors?.name?.[0]
                || "Unable to delete this category.";
            setNotification({ open: true, msg: errorMessage, type: "error" });
            dispatch(resetCategoryState());
        }
        setIsLoading(false);
    }, [deleteCategoryItem])

    useEffect(() => {
        if (bulkUpdate?.code === "success") {
            setIsLoading(false);
            setNotification({ open: true, msg: "Category updated successfully", type: "success" });
            dispatch(resetCategoryState());
            setBulkEdit(false)
            dispatch(getGeneral());
            setPage('1');
            initData();
        } else if (bulkUpdate?.code === "invalid_field") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: "Title and Status are required fields.",
                type: "error",

            })
        }
        setIsLoading(false);
    }, [bulkUpdate])

    useEffect(() => {
        if (categoryListing?.data) {
            setListing(categoryListing.data);
        }
        setIsLoading(false);
    }, [categoryListing])

    useEffect(() => {
        if (exportCategoryDocument?.code === 'success' && exportCategoryDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportCategoryDocument.excel_base64, 'category_listing');
            dispatch(resetCategoryAttachmentState());
        }
        setIsLoading(false);
    }, [exportCategoryDocument])

    useEffect(() => {
        if (checkedAll && categoryListing?.data) {
            const productListingIDs = categoryListing.data.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === categoryListing?.data?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, categoryListing?.data]);

    useEffect(() => {
        if (bulkDelete?.code === "success") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetCategoryState())
            setCheckedAll(false);
            dispatch(getGeneral());
            initData()
        } else if (bulkDelete?.code === "invalid_field") {
            setIsLoading(false);
            setDeleteOpen(false);
            const errorMessage = bulkDelete?.errors?.parent?.[0]
                || bulkDelete?.message
                || "Unable to delete one or more categories.";
            setNotification({
                open: true,
                msg: errorMessage,
                type: "error",
            });
            dispatch(resetCategoryState());
            initData();
        } else if (bulkDelete?.code === "invalid_category" || bulkDelete?.code === "bulk_delete_failed" || bulkDelete?.code === "error") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: bulkDelete?.message || "Unable to delete category",
                type: "error",
            })
            dispatch(resetCategoryState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDelete]);


    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const data = [
        { value: "1", label: "Published" },
        { value: "0", label: "Unpublished" },
    ]

    const showInNavigationMenuOptions = [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" },
    ]

    const handleCellChange = (index, field, value) => {
        if (!listing) {
            console.error("Listing is not initialized");
            return;
        }
        if (!field || value === undefined) {
            console.error("Invalid field or value:", field, value);
            return;
        }

        setListing((prev) => {
            const newData = prev.map((x, idx) =>
                idx === index ? { ...x, [field]: value } : x
            );
            return newData;
        });
    };

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {!bulkEdit && <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />}
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Title ",
            columnID: "category_name",
            minWidth: 250,
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>{
                        bulkEdit ?
                            <CustomTextField
                                values={cellProps?.category_name}
                                onChange={(e) => handleCellChange(idx, "category_name", e)}
                                error={!cellProps?.category_name && error?.category_name}
                                placeholder="Give this category a name"
                            />
                            :
                            <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>
                                {cellProps?.display_name || cellProps?.category_name || '-'}
                            </div>}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Parent",
            accessor: (cellProps) => cellProps?.parent_name || '-',
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Type",
            accessor: (cellProps) => cellProps?.parent_id ? 'Subcategory' : 'Top-level',
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            minWidth: bulkEdit ? 300 : "auto",
            accessor: (cellProps, idx) => {
                return (<React.Fragment>
                    {bulkEdit ?
                        <RadioButtonGroup
                            value={cellProps.status}
                            data={data}
                            setValue={(e) => handleCellChange(idx, "status", e)}
                            flexDirection="row"
                            required="true"
                            name="status"
                            error={!cellProps?.status && error?.status}
                        />
                        :
                        <Label.StatusLabel marginLeft={"0px"} label={cellProps?.status === 1 ? 'published' : 'unpublished'} />}

                </React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Products",
            accessor: (cellProps) => cellProps?.products_count ?? 0,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sort Order",
            columnID: "sort_order",
            accessor: (cellProps, idx) => {
                return (cellProps?.sort_order ?? "-")
            },
        },
        {
            Header: "Show in Navigation Menu",
            columnID: "show_in_navigation_menu",
            minWidth: bulkEdit ? 200 : "auto",
            accessor: (cellProps, idx) => {
                return (<>
                    {
                        bulkEdit ?
                            <RadioButtonGroup
                                value={cellProps.show_in_navigation_menu}
                                data={showInNavigationMenuOptions}
                                setValue={(e) => handleCellChange(idx, "show_in_navigation_menu", e)}
                                required="true"
                                flexDirection={"row"}
                                name="show_in_navigation_menu"
                                error={!cellProps?.show_in_navigation_menu && error?.show_in_navigation_menu}
                            />
                            :
                            cellProps?.show_in_navigation_menu === 1 ? 'Yes' : 'No'

                    }
                </>)
            },
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && !bulkEdit && <Link to={`/edit-settings-product-categories/` + (cellProps.id)}>
                            <CustomIconButton iconName={'ri-pencil-line'} onClick={() => ''} />
                        </Link>}
                        {!bulkEdit && < RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#44d62c',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />}
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
            minWidth: 120
        }
    ]

    const initData = () => {
        let payload = {
            paginate: page,
            sort_order: sort,
            sort_by: sort_by,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus,
            show_in_navigation_menu: filterNavigation === 'all' ? '' : filterNavigation === "Yes" ? 1 : 0,
            filterType: filterType === 'all' ? '' : filterType,
            sort: sort_by,
        }
        dispatch(getCategoryListing(payload))
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            show_in_navigation_menu: filterNavigation === 'all' ? '' : filterNavigation === "Yes" ? 1 : 0,
            type: filterType === 'all' ? '' : filterType,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportCategory({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const handleDelete = () => {
        if (selectedRow?.length > 0) {
            dispatch(bulkDeleteCategory({ ids: selectedRow }))

        } else {
            dispatch(deleteCategory({ id: selectedRow?.id }))
        }

    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus('all');
        setFilterNavigation('all');
        setFilterType('all');
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={8} md={8} lg={8} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} sm={3} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={2.5} sm={2.5} xs={12}>
                        <CustomSelect2 values={filterStatus || 'all'} onChange={(e) => { setPage("1"); setFilterStatus(e || '') }} data={statusListing} placeholder={'All statuses'} />
                    </Grid>
                    <Grid item lg={2.5} md={2.5} sm={2.5} xs={12}>
                        <CustomSelect2 values={filterNavigation || 'all'} onChange={(e) => { setPage("1"); setFilterNavigation(e || '') }} data={[{ id: "Yes", name: "Yes" }, { id: "No", name: "No" }]} placeholder={'All navigation options'} />
                    </Grid>
                    <Grid item lg={2.5} md={2.5} sm={2.5} xs={12}>
                        <CustomSelect2 values={filterType || 'all'} onChange={(e) => { setPage("1"); setFilterType(e || 'all') }} data={typeListing} placeholder={'All types'} />
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4} md={4} lg={4} gap={1} sx={{ display: 'flex', justifyContent: { lg: 'end', sm: 'end' } }} alignItems={'center'}>
                    {editable && <CustomButton
                        title={<><i className="ri-pencil-line" style={{ marginRight: 5 }} />Bulk Edit</>}
                        press={() => { setBulkEdit(!bulkEdit); setListing(categoryListing?.data || []); setSelectedRow([]); setCheckedAll(false); }}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                    {deletable && selectedRow && selectedRow?.length > 0 && <CustomButton
                        title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                        press={() => setDeleteOpen(true)}
                        height={32}
                        borderRadius={15}
                        textColor={"white"}
                        backgroundColor={"#44d62c"}
                        borderStyle={"1px solid #44d62c"}
                    />}
                </Grid>
            </Grid>
        )
    }

    const handleSubmit = () => {
        let payload = listing?.map(item => ({
            id: item.id,
            name: item.category_name,
            status: parseInt(item.status),
            show_in_navigation_menu: item.show_in_navigation_menu,
        }));
        setIsLoading(true);
        dispatch(bulkUpdateCategory({ data: payload }));
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !categoryListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        title="Categories"
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: "Categories", link: "#" },
                        ]}
                    >
                        {bulkEdit ?
                            <CustomButton
                                title={"Save Changes"}
                                press={() => handleSubmit()}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                            :
                            creatable && <CustomButton
                                title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Categories</>}
                                press={() => navigate("/add-settings-product-categories")}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />

                        }
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={listing || []}
                        pageSize={length}
                        totalPage={categoryListing?.data?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={categoryListing?.last_page || 1}
                    />
                </Container>
            </div>
            <DeleteModal
                open={deleteOpen}
                close={() => { setDeleteOpen(false); setSelectedRow([]); setCheckedAll(false); }}
                submit={() => handleDelete()}
                module={'category'}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Category, Login }) {
    console.log("sfdsfd", Category)
    return {
        categoryListing: Category.categoryListing,
        exportCategoryDocument: Category.exportCategory,
        userPermission: Login.permissionArry,
        deleteCategoryItem: Category.deleteCategory,
        bulkDelete: Category.bulkDeleteCategory,
        bulkUpdate: Category.bulkUpdateCategory,
        error: Category.error?.errors,
    };
}

export default connect(mapStateToProps)(ProductCategoriesSetting);
